









































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {EmailDetailItemInfo} from "@/store/email/statistic/types";
import EmailPreviewDialog from '@/components/Email/EmailPreviewDialog.vue';
import EmailEventsDetail from '@/components/Email/EmailEventsDetail.vue';
import { colorClassByStatus } from "@/utils/page-utils";
import {dateFilter} from "@/utils/date-util";
import {notifyError} from "@/utils/notify-helper";
import {ActionLog} from "@/store/auth/types";
import {MsgTransports} from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {InputWings} from "wings-ui-components";

@Component({
  components: {EmailPreviewDialog, EmailEventsDetail, InputWings},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class EmailDetailInfo extends Vue {
  @Action("getEmailEventsStatisticDetailInfo") actionGetStatisticDetailInfo: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {};
  transport = MsgTransports.EMAIL;

  defaultInfo(): EmailDetailItemInfo {
    return new EmailDetailItemInfo()
  }

  messageInfo = this.defaultInfo();

  async created() {
    if (this.$route.params.id) {
      this.messageInfo.id = this.$route.params.id
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Viewing",
          actionStatus: 'success',
          objectType: "Event",
          addititionalInfo: getTranslatedParams({id: this.$route.params.id})
        }
        const resp = await this.actionGetStatisticDetailInfo({message_id: this.$route.params.message_id, id: this.$route.params.id});
        await this.actionLog(this.logObject);
        this.messageInfo = Object.assign({}, this.messageInfo, resp.data);
      } catch(error) {
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        notifyError(error);
      }
    }
  }

  back(): void {
    this.$router.back();
  }

}
